import React, { useEffect, useMemo, useRef, useState } from "react";
import countries from "./countries.json"; // full list
import WhatsAppNumberSC from "./whatsapp_number.styles.jsx";

const DEFAULT_COUNTRIES = ["IN", "US", "DE", "JP"];

export default function WhatsappNumberInput({ onChange }) {
    const wrapperRef = useRef(null);

    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [phone, setPhone] = useState("");
    const [country, setCountry] = useState(
        countries.find(c => c.code === "IN")
    );

    /* ---------- outside click ---------- */
    useEffect(() => {
        const handler = e => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
                setSearch("");
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    /* ---------- country filtering ---------- */
    const results = useMemo(() => {
        if (!search) {
            return countries
                .filter(c => DEFAULT_COUNTRIES.includes(c.code))
                .slice(0, 4);
        }

        return countries
            .filter(c =>
                `${c.name} ${c.dial}`
                    .toLowerCase()
                    .includes(search.toLowerCase())
            )
            .slice(0, 4);
    }, [search]);

    /* ---------- normalized number ---------- */
    const normalized = useMemo(() => {
        return `${country.dial}${phone.replace(/\D/g, "")}`;
    }, [country, phone]);

    useEffect(() => {
        onChange?.(normalized);
    }, [normalized]);

    return <WhatsAppNumberSC ref={wrapperRef}>
            <label className="wnLabel">WhatsApp number*</label>

            {/* INPUT */}
            <div className="inputBox">
                <span className="dial" onClick={() => setOpen(true)}>{country.dial}</span>

                <input
                    type="tel"
                    value={phone}
                    placeholder="Enter number"
                    onChange={e => setPhone(e.target.value)}
                    onClick={e => e.stopPropagation()}
                />
            </div>

            {/* DROPDOWN */}
            {open && (
                <div className="dropdown">
                    <input
                        placeholder="Search country"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="search"
                    />

                    {results.map(c => (
                        <div
                            key={c.code}
                            className={`row ${c.code === country.code ? 'selected': ''}`}
                            onClick={() => {
                                setCountry(c);
                                setOpen(false);
                                setSearch("");
                            }}
                        >
                            <span>{c.name}</span>
                            <span className="code">{c.dial}</span>
                        </div>
                    ))}
                </div>
            )}
        </WhatsAppNumberSC>;
}
